module.exports = __webpack_public_path__ + "static/media/icon-nutricional.9f26e8d1.svg";